(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Events = Lfl.Events || {};

    (function (Events, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Events, 'Helpers')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * A set of helper functions.
         *
         * @memberOf Lfl.Events
         */
        Lfl.Events.Helpers = Events.Helpers || {};

        (function (Helpers, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */
            /**
             * Whether the browser supports the passive scrolling listener option.
             *
             * @type {boolean}
             */
            var supportsPassiveOption;

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * Creates a event listener options in the corect format.
             * @memberOf Lfl.Events.Helpers
             */
            Helpers.getEventListenerOptions = function (capture, passive) {
                return Helpers.browserSupportsPassive() ? {
                    capture: capture,
                    passive: passive
                } : capture;
            };

            /**
             * Does the current browser support passive event listeners?
             * @memberOf Lfl.Events.Helpers
             */
            Helpers.browserSupportsPassive = function () {
                if (typeof supportsPassiveOption === 'undefined') {
                    // For details see
                    //     https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
                    //     https://github.com/cubiq/iscroll/issues/1130

                    supportsPassiveOption = false;
                    try {
                        addEventListener("test", null, Object.defineProperty({}, 'passive', {
                            get: function () {
                                supportsPassiveOption = true;
                            }
                        }));
                    } catch (e) {
                    }
                }
                return supportsPassiveOption;
            };
            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(Events.Helpers, jQuery));
    }(Lfl.Events, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
